const unitsToFactor = new Map();
unitsToFactor.set('Bytes', 0);
unitsToFactor.set('KB', 1);
unitsToFactor.set('MB', 2);
unitsToFactor.set('GB', 3);
unitsToFactor.set('TB', 4);
unitsToFactor.set('PB', 5);

/**
 * Given amount and data unit, converts them into bytes.
 * @returns the input in bytes
 */
export function convertToBytes(value: number, unit: string): number {
  const u = unitsToFactor.get(unit);
  if (u !== undefined) {
    const factor = 3 * u;
    return Math.round(value * 10 ** factor);
  }
  return -1;
}
